import React from 'react';
import './Login.css'; // Reuse the same CSS for consistency
import Logo from '../assets/Images/Logo.png';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../services/apiService'; // adjust path if needed
import { useDispatch } from 'react-redux';
import { setUser } from '../Redux/userSlice'; 

const Login = () => {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');

  const navigate = useNavigate();

  const dispatch = useDispatch();
const [errorMsg, setErrorMsg] = React.useState('');

const handleLogin = async () => {
  setErrorMsg(''); // Clear previous error

  if (!email || !password) {
    setErrorMsg('Please enter email and password');
    return;
  }

  try {
    const response = await apiService.login({ email, password });
    console.log('Login response:', response); // Log the entire response for debugging
    const statusCode = response.statusCode;
    const body = JSON.parse(response.body || '{}');
    console.log('Parsed body:', body); 
    console.log('Status code:', statusCode)
    if (response) {
      console.log(response)
      dispatch(setUser(response)); // adjust if needed
      localStorage.setItem('access_token', response.email || 'mock-token');
      navigate('/landing');
    } else {
      setErrorMsg(body.error || 'Login failed'); // <-- updated to use `error`
    }
  } catch (error) {
    console.error(error);
    setErrorMsg('Unable to connect. Please try again later.');
  }
};




  

  return (
    <div className="signup-container">
      <div className="signup-wrapper">
        <div className="signup-wrapper-container">
          <div className="signup-left">
            <div className="signup-left-header">
              <h2 className="signup-title">Welcome Back</h2>
              <p className="signup-subtitle">Login to your account</p>
            </div>

            <div className="signup-form">
              <InputText
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <InputText
                placeholder="Password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {errorMsg && <div className="error-message">{errorMsg}</div>}
              <Button
                label="Login"
                className="signup-btn"
                onClick={handleLogin}
              />
              <p className="login-redirect">
                <Link to="#">Forgot Password?</Link>
              </p>
              <p className="login-redirect">
                Don't have an account? <Link to="/signup">Sign up</Link>
              </p>
            </div>
          </div>

          <div className="signup-right">
            <div className="signup-right-content">
              <div className='signup-right-header'>
              <img
                src={Logo}
                alt="Contract Review Logo"
                className="signup-right-logo"
              />

              </div>

              <h3 className="signup-right-heading">Secure Contract Access</h3>
              <ul className="signup-features">
                <li><i className="pi pi-check check-icon" /><span>Access your contracts anytime</span></li>
                <li><i className="pi pi-check check-icon" /><span>View flagged clauses instantly</span></li>
                <li><i className="pi pi-check check-icon" /><span>Stay updated with legal tips</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
